import React, { Component } from "react";
import { API_TOKEN_NAME, IMAGE_URL, SITE_URL } from "../../../constants";
import { scAxiosAdmin } from "../../..";
import "react-toastify/dist/ReactToastify.css";
import banner_img from "../../../images/banner-profile.jpg";
import SubPopupIndex2 from "../../../component/frontend/SubPopupIndex2";
import $ from "jquery";
import icon2 from "../../../images/icon-2.png";
import { Link, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import SEO from "../../Seo";
import BookAppointmentPopup from "../BookAppointmentPopup";

const getDoctorsbyDept = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/doctors/getdoctorsbydepartment/" + id, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSideBarVideoLInk = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/settings/30", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res)).catch((err) => reject(err));
  });
};

const getSingleDoctorData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/department/getsingledepartment/" + id, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const getAllDepartments = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/department/getdepartments", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

class SingleDepartmentView extends Component {
  state = {
    department_name: "",
    videoLInk: "",
    packages: [],
    investigations: [],
    status_list: "",
    image: "",
    banner_image: "",
    departments: [],
    showDoctorSearchPopup: false,
    doctors: [],
    descriptions: [],
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
    var doctor_avability_time = $(
      "input[name='doctor_avability_time']:checked"
    ).val();
    if (doctor_avability_time) {
      $(".doctor_search_list_popup").css("visibility", "visible");
      $(".doctor_search_list_popup").addClass("show");
      this.setState({
        showDoctorSearchPopup: true,
      });
    }
  };

  refreshDepartments = (event) => {
    getAllDepartments()
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          this.setState({ departments: records });
        } else {
          this.setState({ departments: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  refreshSideBarVideoLink = (event) => {
    getSideBarVideoLInk()
      .then((res) => {
        if (res.status === 200) {
          var records = res.data.value;
          this.setState({ videoLInk: records });
        } else {
          this.setState({ videoLInk: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  refreshGetDoctorData = (id) => {
    getSingleDoctorData(id)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;

          this.setState({
            department_name: records.department_name,
            doctors: records.doctors_mave,
            packages: records.packages_mave,
            investigations: records.investigations_mave,
            // department_desc_one: records.department_desc_one,
            // department_desc_two: records.department_desc_two,
            // department_desc_three: records.department_desc_three,
            // department_desc_four: records.department_desc_four,
            // department_desc_five: records.department_desc_five,
            // department_desc_six: records.department_desc_six,
            // department_desc_seven: records.department_desc_seven,
            // department_desc_eight: records.department_desc_eight,
            // department_desc_nine: records.department_desc_nine,
            // department_desc_ten: records.department_desc_ten,
            status_list: JSON.parse(records.status_list),
            descriptions: JSON.parse(records.description_list) || [],
            image: records.image,
            banner_image: records.banner_image,
          });
        } else {
          this.setState({
            department_name: "",
            // department_desc_one: "",
            // department_desc_two: "",
            // department_desc_three: "",
            // department_desc_four: "",
            // department_desc_five: "",
            // department_desc_six: "",
            // department_desc_seven: "",
            // department_desc_eight: "",
            // department_desc_nine: "",
            // department_desc_ten: "",
            status_list: "",
            image: "",
            banner_image: "",
            descriptions: [],
            doctors: [],
            packages: [],
            investigations: [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    let department_name_string = this.props.currentDocId;
    let department_id = department_name_string.split("~").pop();
    //let doctor_name = doctor_name_string.split("~")[0];
    //let new_doctor_name = doctor_name.replaceAll('-', ' ');
    this.refreshGetDoctorData(department_id);
    getDoctorsbyDept(department_id).then((res) => {
      if (res.status === true) {
        var records = res.data;
        // this.setState({ doctors: records });
      }
    });
    this.refreshDepartments();
    this.refreshSideBarVideoLink();
  }

  render() {
    return (
      <div>
        <SEO
          title={
            this.state.department_name +
            " | Best Hospital in Bangladesh | United Hospital"
          }
          description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          pathSlug="/"
          keywords="Department, departments, Cardiac Surgery, Single department"
        />
        <Helmet>
          <meta
            name="description"
            content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "LocalBusiness",
              name: "United Hospital Limited",
              image:
                "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
              telephone: "10666",
              email: "info@uhlbd.com",
              address: {
                "@type": "PostalAddress",
                streetAddress: "plot 15, Road 71, Gulshan",
                addressLocality: "Dhaka",
                addressRegion: "Dhaka",
                addressCountry: "Bangladesh",
                postalCode: "1212",
              },
              openingHoursSpecification: {
                "@type": "OpeningHoursSpecification",
                opens:
                  "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
              },
              url: "http://www.uhlbd.com/",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
                ratingCount: "756",
              },
              review: {
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "abdul kahar",
                },
                datePublished: "2019-02-12",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "3.9",
                  bestRating: "5",
                  worstRating: "1",
                },
                reviewBody:
                  "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
              },
            })}
          </script>
          <meta
            name="Subject"
            content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
          />
          <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
          <meta name="Googlebot" content="all" />
          <meta http-equiv="imagetoolbar" content="no" />
          <meta name="robots" content="index, follow" />
          <meta name="copyright" content="Copyright &copy; uhlbd.com" />
          <meta name="owner" content="United Hospital" />
          <meta name="author" content="dcastalia.com" />
          <meta name="Rating" content="General" />
          <meta name="distribution" content="Global" />
          <meta
            name="classification"
            content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta
            names="apple-mobile-web-app-status-bar-style"
            content="black-translucent"
          />
          <meta
            name="msvalidate.01"
            content="16C4E0B16E39354E550F64BD707F6A97"
          />
        </Helmet>
        <div
          className=""
          id="giveMargin"
          style={{ backgroundColor: "#fef3e9" }}
        >
          <section
            className="top-section"
            style={{ backgroundColor: "#f58220" }}
          >
            <img
              style={{
                maxWidth: "1920px",
                maxHeight: "370px",
                objectFit: "cover",
                objectPosition: "center",
              }}
              src={
                this.state.banner_image
                  ? IMAGE_URL + "DepartmentImage/" + this.state.banner_image
                  : banner_img
              }
              alt="banner-profile"
              className="w-100"
            />
          </section>

          <section className="prof-dr mt-2 section-gap py-4">
            <div className="container">
              <h3
                className="text-center mb-4 text-center"
                style={{
                  color: "#0C807D",
                  fontWeight: "700",
                  width: "100%",
                }}
              >
                {this.state.department_name}
              </h3>

              {this.state.doctors.length > 0 ? (
                <div
                  className="row mb-2 justify-content-center justify-content-md-start"
                  style={{
                    backgroundColor: "#fff",
                    width: "99.8%",
                    margin: "0 auto",
                  }}
                >
                  {this.state.doctors.map((doctor, ind) => {
                    let name = doctor.doctor_name;

                    return (
                      <div
                        className="col-1 col-md-6 col-xl-4 mb-2 mt-2 doctor-list singleDoctorWidth"
                        key={ind}
                        id="consultation and appointment"
                        style={{ margin: "7px" }}
                      >
                        <div
                          className="d-flex list_content_sec"
                          style={{
                            width: "100%",
                            height: "80vh",
                            maxHeight: "167px",
                            overflow: "hidden",
                          }}
                        >
                          {/* Image portion */}
                          <div className="" style={{ width: "40%" }}>
                            {doctor.doctor_profile ? (
                              <img
                                style={{
                                  objectFit: "cover",
                                  objectPosition: "top",
                                  width: "100%",
                                  borderTopLeftRadius: "10px",
                                  borderBottomLeftRadius: "10px",
                                }}
                                src={
                                  IMAGE_URL +
                                  "DoctorProfileImg/" +
                                  doctor.doctor_profile
                                }
                                alt="avtars"
                                height={"100%"}
                              />
                            ) : (
                              <img src={icon2} alt="Bitmap-3" width={"100%"} />
                            )}
                          </div>

                          {/* description portion */}
                          <div
                            className="h-full px-0 relative description"
                            style={{
                              width: "60%",
                            }}
                          >
                            <div className="w-full px-2">
                              <div className="pt-3">
                                <h6 style={{ fontWeight: "700" }}>
                                  {doctor.doctor_name}
                                </h6>
                                <p
                                  style={{ fontSize: "12px" }}
                                  title={doctor.degree}
                                >
                                  {doctor.degree
                                    ? doctor.degree.length > 90
                                      ? `${doctor.degree.slice(0, 90)}...`
                                      : doctor.degree
                                    : ""}
                                </p>
                              </div>
                            </div>

                            {/* Button portion */}
                            <div
                              className="w-full"
                              style={{
                                position: "absolute",
                                bottom: 10,
                                right: 10,
                                width: "85%",
                              }}
                            >
                              <Link
                                to={`/consultant/${doctor.slug}`}
                                style={{ textDecoration: "none" }}
                              >
                                {" "}
                                <button
                                  className="mt-2 text-light"
                                  style={{
                                    border: "none",
                                    backgroundColor: "#0C807D",
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    paddingRight: "5px",
                                    paddingLeft: "5px",
                                    fontSize: "15px",
                                    width: "100%",
                                    borderRadius: "5px",
                                  }}
                                >
                                  View Details
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>

                        {/* </Link> */}
                      </div>
                    );
                  })}
                </div>
              ) : (
                ""
              )}

              <div className="box-of-about border-section mb-4">
                <div className="row g-2">
                  <div className="col-lg-8 col-md-12">
                    <div className="text-profile">
                      {this.state.descriptions.length > 0
                        ? this.state.descriptions
                            .filter((item) => item.visibility === 1)
                            .map((item) => {
                              return (
                                <div
                                  className="col-lg-12 col-md-12"
                                  // key={item.field_name}
                                >
                                  <p
                                    className="b"
                                    dangerouslySetInnerHTML={{
                                      __html: item.value,
                                    }}
                                  ></p>
                                </div>
                              );
                            })
                        : ""}
                    </div>

                    <div className="text-profile">
                      <div
                        class="accordion px-0"
                        id="accordionPanelsStayOpenExample"
                      >
                        <div class="accordion-item b">
                          <h2
                            class="accordion-header"
                            id="panelsStayOpen-headingTwo"
                          >
                            <button
                              class="accordion-button collapsed px-2"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#panelsStayOpen-collapseTwo"
                              aria-expanded="false"
                              aria-controls="panelsStayOpen-collapseTwo"
                            >
                              Packages
                            </button>
                          </h2>
                          <div
                            id="panelsStayOpen-collapseTwo"
                            class="accordion-collapse collapse"
                            aria-labelledby="panelsStayOpen-headingTwo"
                          >
                            <div class="accordion-body">
                              {this.state.packages.length > 0
                                ? this.state.packages.map((item, index) => {
                                    return (
                                      <div
                                        className="col-lg-12 col-md-12"
                                        key={index}
                                      >
                                        <h3>{item.name}</h3>
                                        <p>
                                          <strong>Package Type:</strong>{" "}
                                          {item.package_type}
                                        </p>
                                        <p>
                                          <strong>Nature:</strong>{" "}
                                          {item.package_nature}
                                        </p>
                                        <p
                                          className="b"
                                          dangerouslySetInnerHTML={{
                                            __html: item.description,
                                          }}
                                        ></p>
                                        <p>
                                          <strong>Amount:</strong>{" "}
                                          {item.opd_amount} BDT
                                        </p>
                                        <p>
                                          <strong>Created At:</strong>{" "}
                                          {new Date(
                                            item.created_at
                                          ).toLocaleDateString()}
                                        </p>
                                        <hr className="w-75" />
                                      </div>
                                    );
                                  })
                                : "No packages available"}
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item b">
                          <h2
                            class="accordion-header"
                            id="panelsStayOpen-headingThree"
                          >
                            <button
                              class="accordion-button collapsed px-2"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#panelsStayOpen-collapseThree"
                              aria-expanded="false"
                              aria-controls="panelsStayOpen-collapseThree"
                            >
                              Investigations
                            </button>
                          </h2>
                          <div
                            id="panelsStayOpen-collapseThree"
                            class="accordion-collapse collapse"
                            aria-labelledby="panelsStayOpen-headingThree"
                          >
                            <div class="accordion-body">
                              {this.state.investigations.length > 0
                                ? this.state.investigations.map(
                                    (item, index) => {
                                      return (
                                        <div
                                          className="col-lg-12 col-md-12"
                                          key={index}
                                        >
                                          <h3>
                                            {index + 1}- {item.Product_Name}
                                          </h3>
                                          <p>
                                            <strong>Product Group:</strong>{" "}
                                            {item.Product_Group}
                                          </p>
                                          <p>
                                            <strong>OPD Amount:</strong>{" "}
                                            {item.opd_amount} BDT
                                          </p>
                                          <p>
                                            <strong>IPD Price:</strong>{" "}
                                            {item.ipd_price} BDT
                                          </p>
                                          {/* <p>
                                            <strong>Created At:</strong>{" "}
                                            {new Date(
                                              item.created_at
                                            ).toLocaleDateString()}
                                          </p> */}
                                          <hr className="w-75" />
                                        </div>
                                      );
                                    }
                                  )
                                : "No investigation available"}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {this.state.packages.length > 0
                        ? this.state.packages.map((item, index) => {
                            return (
                              <div className="col-lg-12 col-md-12" key={index}>
                                <h3>{item.name}</h3>
                                <p>
                                  <strong>Package Type:</strong>{" "}
                                  {item.package_type}
                                </p>
                                <p>
                                  <strong>Nature:</strong> {item.package_nature}
                                </p>
                                <p
                                  className="b"
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                ></p>
                                <p>
                                  <strong>Amount:</strong> {item.opd_amount} BDT
                                </p>
                                <p>
                                  <strong>Created At:</strong>{" "}
                                  {new Date(
                                    item.created_at
                                  ).toLocaleDateString()}
                                </p>
                              </div>
                            );
                          })
                        : ""} */}
                    </div>
                  </div>

                  {/* <div className="col-lg-8 col-md-12">
                    <div className="text-profile">
                      {this.state.status_list
                        ? JSON.parse(this.state.status_list)
                            .filter((item) => item.visibility === 1)
                            .map((item) => {
                              const fieldContent = this.state[item.field_name];
                              return fieldContent === "<p><br></p>" &&
                                fieldContent != null ? null : (
                                <div
                                  className="col-lg-12 col-md-12"
                                  key={item.field_name}
                                >
                                  <p
                                    className="b"
                                    dangerouslySetInnerHTML={{
                                      __html: fieldContent,
                                    }}
                                  ></p>
                                </div>
                              );
                            })
                        : ""}
                    </div>
                  </div> */}

                  <div
                    className="col-lg-4 col-md-12 d-none d-md-block pt-2"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      // width: "100%",
                      // maxWidth: "370px",
                    }}
                  >
                    <div className="text-profile" id="mobile-part">
                      <div id="sidebar-2" className="row">
                        <div className="col-md-12 sidebar-item ">
                          <a
                            className="category-list-link open-cat-list"
                            href="#"
                          >
                            Select Departments
                          </a>
                          <ul
                            className="list-unstyled category-list patients-category-list"
                            id="department-list-sidebar"
                          >
                            {this.state.departments.length > 0
                              ? this.state.departments.map((department) => {
                                  var department_name =
                                    department.department_name;
                                  var new_department_name =
                                    department_name.replaceAll(" ", "-");
                                  return (
                                    <li>
                                      <a
                                        className=""
                                        href={
                                          SITE_URL +
                                          "/departments/" +
                                          department.slug
                                        }
                                      >
                                        {department_name}
                                      </a>
                                    </li>
                                  );
                                })
                              : ""}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="bookarea mt-3 d-none d-md-block mb-3"
                      style={{ position: "sticky", zIndex: "3333", top: 100 }}
                    >
                      <iframe
                        width="100%"
                        height="315"
                        src={this.state.videoLInk}
                        // src="https://www.youtube.com/embed/nTORUrJ7eN8?si=NAmLLBgAX3X8lFg4"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted"
                        allowfullscreen
                      ></iframe>
                      <h5
                        className="text-center p-2 text-light"
                        style={{
                          backgroundColor: "#f58220",
                          marginTop: "-6px",
                        }}
                      >
                        Call Emergency Line
                        <br />
                        10666
                      </h5>
                      <img
                        src={
                          "https://www.uhlbd.com/resources/images/contact.jpg"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {this.state.showDoctorSearchPopup ? (
          <SubPopupIndex2
            showPopup={this.state.showDoctorSearchPopup}
            doctorname={this.state.doctor_name}
          />
        ) : null}
        <BookAppointmentPopup></BookAppointmentPopup>
      </div>
    );
  }
}
export default SingleDepartmentView;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/SingleDepartmentView.js